import { Body1 as o } from "./index.es93.js";
import { Body2 as r } from "./index.es94.js";
import { Heading1 as m } from "./index.es95.js";
import { Heading2 as i } from "./index.es96.js";
import { Heading3 as p } from "./index.es97.js";
import { Heading4 as t } from "./index.es98.js";
import { Heading5 as e } from "./index.es99.js";
import { Heading6 as f } from "./index.es100.js";
import { Heading7 as a } from "./index.es101.js";
import { Overline as d } from "./index.es102.js";
import { Small as n } from "./index.es103.js";
import { TopHeader as g } from "./index.es104.js";
var b = {
  Heading1: m,
  Heading2: i,
  Heading3: p,
  Heading4: t,
  Heading5: e,
  Heading6: f,
  Heading7: a,
  Body1: o,
  TopHeader: g,
  Body2: r,
  Small: n,
  Overline: d
};
export { b as Typography };